<template>
  <n-config-provider id="config-provider" :theme="darkTheme" :locale="zhCN" :date-locale="dateZhCN">
    <n-message-provider>
      <router-view></router-view>
    </n-message-provider>
    <n-global-style />
  </n-config-provider>
</template>

<script>
import { darkTheme, zhCN, dateZhCN } from 'naive-ui'
import 'reset-css'

export default {
  name: 'App',
  setup() {
    return {
      darkTheme,
      zhCN,
      dateZhCN
    }
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100vh;
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
  outline: none;
  color: inherit;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  .n-config-provider {
    height: 100%;
  }
}
</style>
